import React, {
  ComponentProps,
  CSSProperties,
  ReactNode,
  useContext,
  useState,
} from 'react'

import { PopupDanger } from '@hhgtech/hhg-components'
import Close from 'components/atoms/icons/Close'
import { AppContext } from 'state/appContext'

// import { TogetherDataContext } from '../common/TogetherDataWrapper'
import ArrowLeft from '../icons/ArrowLeft'
import {
  StyledBackBtn,
  StyledBody,
  StyledCloseBtn,
  StyledFooter,
  StyledHeader,
  StyledHeading,
  StyledWrapper,
} from './index.styled'

export type Props = {
  heading?: string
  handleBackFn?: () => void
  handleCloseFn?: () => void
  onConfirmClose?: () => void
  popupConfirmBackProps?: ComponentProps<typeof PopupDanger>
  popupConfirmCloseProps?: ComponentProps<typeof PopupDanger>
  children: ReactNode
  footer?: ReactNode
  styleBody?: CSSProperties
  style?: CSSProperties
}

const Section = ({
  heading = '',
  handleBackFn,
  handleCloseFn,
  children,
  footer,
  styleBody,
  popupConfirmBackProps,
  popupConfirmCloseProps,
  ...rest
}: Props) => {
  const { state } = useContext(AppContext)
  const { isLoggedIn } = state
  const [showConfirmBackPopup, setShowConfirmBackPopup] = useState<boolean>()
  const [showConfirmClosePopup, setShowConfirmClosePopup] = useState<boolean>()
  return (
    <>
      <StyledWrapper {...rest}>
        <StyledHeader>
          {(handleBackFn || popupConfirmBackProps) && (
            <StyledBackBtn
              onClick={
                popupConfirmBackProps
                  ? () => {
                      setShowConfirmBackPopup(true)
                    }
                  : handleBackFn
              }
            >
              <ArrowLeft />
            </StyledBackBtn>
          )}
          <StyledHeading>{heading}</StyledHeading>
          {(handleCloseFn || popupConfirmCloseProps) && (
            <StyledCloseBtn
              onClick={
                popupConfirmCloseProps
                  ? () => {
                      setShowConfirmClosePopup(true)
                    }
                  : handleCloseFn
              }
            >
              <Close />
            </StyledCloseBtn>
          )}
        </StyledHeader>
        <StyledBody
          data-is-login={isLoggedIn}
          data-has-footer={Boolean(footer)}
          style={styleBody}
        >
          {children}
        </StyledBody>
        {footer && <StyledFooter>{footer}</StyledFooter>}
      </StyledWrapper>
      {showConfirmBackPopup && (
        <PopupDanger
          onClose={() => setShowConfirmBackPopup(false)}
          {...popupConfirmBackProps}
        />
      )}
      {showConfirmClosePopup && (
        <PopupDanger
          onClose={() => setShowConfirmClosePopup(false)}
          {...popupConfirmCloseProps}
        />
      )}
    </>
  )
}

export { Section }
